import { TokenExplorerView } from "@/components/explorer/TokenExplorerView";
import { PageHero } from "@/components/ui/PageHero";

/** In-SPA MMK ledger explorer — AppShell DeFi glass (not Agent chrome). */
export default function ExploreMmkPage() {
	return (
		<div className="pb-16">
			<PageHero
				eyebrow="Explorer"
				title="MMK Explorer"
				subtitle="On-chain MotokoMaker ledger — supply, fee, principal balance, and recent index transactions."
			/>
			<div className="container mx-auto px-4">
				<TokenExplorerView token="MMK" title="MotokoMaker" />
			</div>
		</div>
	);
}
